/**
 * The accessible name of a CMS picture.
 *
 * Editors maintain alt text on the media itself, in Strapi's media library,
 * and the backend ships it as `alternativeText` on every image (see
 * `createImageDto`). A widget that renders a picture as *content* must pass
 * this to `alt`; one that renders a decorative asset (a static icon beside its
 * own label, say) keeps `alt=""` and does not call this.
 *
 * `fallback` is for widgets that already had a sensible name — the Seals
 * widget's caption, an offer's title — which stays in use while the media
 * carries no alt text of its own. The default is the empty string: an image
 * whose alt text an editor has not filled in is treated as decorative, which
 * is the accessible choice over inventing a name.
 */
export function imageAlt(
  media: { alternativeText?: string | null } | null | undefined,
  fallback = '',
): string {
  return media?.alternativeText?.trim() || fallback;
}
